import { render, staticRenderFns } from "./QuizLayout.vue?vue&type=template&id=79ce1f16&scoped=true&"
import script from "./QuizLayout.vue?vue&type=script&lang=js&"
export * from "./QuizLayout.vue?vue&type=script&lang=js&"
import style0 from "./QuizLayout.vue?vue&type=style&index=0&id=79ce1f16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ce1f16",
  null
  
)

export default component.exports